import React, {Component} from 'react';
import {Nav, NavItem, NavLink, TabContent} from 'reactstrap';
import classNames from 'classnames';
import {inject, observer} from "mobx-react";
import FirstAsidePageUser from "./FirstAsidePageUser";
import SecondAsidePage from "./SecondAsidePage";
import ThreeAsidePage from "./ThreeAsidePage";

const ONGLETS = [
    {id: '1', icone: 'icon-user', titre: 'Client'},
    {id: '2', icone: 'icon-settings', titre: 'Réglages'},
    {id: '3', icone: 'fa fa-print', titre: 'Impressions'},
];

const DefaultAside = inject("rootStore")(observer(class DefaultAside extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
    };
  }
      get injected() {
        return this.props
      }


  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    return (
      <React.Fragment>
        <Nav tabs className="menu-reglages-onglets">
          {ONGLETS.map(onglet => (
            <NavItem key={onglet.id}>
              <NavLink className={classNames({ active: this.state.activeTab === onglet.id })}
                       onClick={() => this.toggle(onglet.id)}>
                <i className={onglet.icone} aria-hidden="true"></i>
                <span>{onglet.titre}</span>
              </NavLink>
            </NavItem>
          ))}
        </Nav>

        <TabContent activeTab={this.state.activeTab} className="menu-reglages">
            <FirstAsidePageUser/>
            <SecondAsidePage/>
            <ThreeAsidePage/>
        </TabContent>
      </React.Fragment>
    );
  }
}
));

export default DefaultAside;
